import React from 'react';
import PropTypes from 'prop-types';
import MainTop from '../common/MainTop';
import MainGrid1 from './MainGrid1';
import MainGrid2 from './MainGrid2';
import MainGrid3 from './MainGrid3';
import MainGrid4 from './MainGrid4';
import MainGridError from './MainGridError';
import FilterBar from '../common/FilterBar';
import FilterForm from './FilterForm';
import ErrorComments from '../common/ErrorComments';
import InfoComments from '../common/InfoComments';
import * as title from '../../../constants/common/ConstTitle';
import * as defaultValue from '../../../constants/common/ConstDefaultValue';
import * as commonLogic from '../../../logic/CommonLogic';
import * as GridTitle from '../../../constants/K007/GridTitle';
import * as ContextTitle from '../../../constants/K007/ContextSortTitle';
import * as cookies from '../../../logic/Cookies';

/**
 * Content
 */
class Content extends React.Component {

  componentDidMount() {
    this.checker = setInterval(this.props.actions.checkAPICall, defaultValue.CHECK_API_CALL_DELAY);
  }

  componentWillUnmount() {
    clearInterval(this.cheker);
  }


  render() {
    // error
    if (this.props.data.error != null) {
      commonLogic.loadingFadeOut();

      return (
        <div id="content" className="fix_height">
          <div id="main">
            <ErrorComments error={this.props.data.error} />
          </div>
        </div>
      );
    }

    // not found
    if (this.props.data.remainderAPICount > 0 && this.props.data.scrollEnd === false) {
      if (this.props.data.msgID === 'M0004') {
        commonLogic.loadingFadeIn();
      } else {
        commonLogic.loadingFadeOut();
      }

      return (
        <div id="content" className="fix_height">
          <div id="main">
            <MainTop title={title.TITLE_NAME_K007} />
            <MainGridError dispFlg={this.props.data.dispFlg} actions={this.props.actions} />
            <InfoComments msgID={this.props.data.msgID} />
          </div>
          <FilterBar />
          <FilterForm actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />
        </div>
      );
    }

    // スクロールの場合
    if (this.props.data.scrollEnd === true) {
      commonLogic.loadingFadeIn();
    } else {
      //スクロール位置の調整
      commonLogic.setScrollLeft(cookies.getItem('scrollPosition'));

      commonLogic.loadingFadeOut();
    }

    // 日付OFF・パチンコ
    let mainGrid = <MainGrid1 data={this.props.data} actions={this.props.actions} />;
    // 日付ON・パチンコ
    if (this.props.data.dispFlg === 2) {
      mainGrid = <MainGrid2 data={this.props.data} actions={this.props.actions} />;
    }
    // 日付OFF・スロット
    if (this.props.data.dispFlg === 3) {
      mainGrid = <MainGrid3 data={this.props.data} actions={this.props.actions} />;
    }
    // 日付ON・スロット
    if (this.props.data.dispFlg === 4) {
      mainGrid = <MainGrid4 data={this.props.data} actions={this.props.actions} />;
    }
    let style = {
      display: 'none'
    };
    let sortDisplay = "";
    if (this.props.data.sortKey != null) {
      style.display = 'block';
      sortDisplay = "　【ソート条件】";
      let sortKeyName = "";
      if (this.props.data.pskubun == '0') {
        GridTitle.GRID_TITLE_PACHI.map((item) => {
          if (this.props.data.sortKey == item.key) {
            sortKeyName = item.name;
          }
        });
      } else {
        GridTitle.GRID_TITLE_SLOT.map((item) => {
          if (this.props.data.sortKey == item.key) {
            sortKeyName = item.name;
          }
        });
      }

      sortDisplay = sortDisplay + sortKeyName;

      if (this.props.data.dayFlg == '1' && !ContextTitle.MODEL_SORT_KEY.includes(this.props.data.sortKey)) {
        if (this.props.data.sortDay == 'weekday') {
          sortDisplay = sortDisplay + ' 平日';
        } else if (this.props.data.sortDay == 'holiday') {
          sortDisplay = sortDisplay + ' 休日';
        } else {
          sortDisplay = sortDisplay + ' 期間';
        }
      }

      if (this.props.data.sortOrder == 'asc') {
        sortDisplay = sortDisplay + ' (昇順)';
      } else {
        sortDisplay = sortDisplay + ' (降順)';
      }
    }
    return (
      <div id="content" className="fix_height">
        <div id="main">
          <MainTop title={title.TITLE_NAME_K007} />
          <div className="condition_display" style={style}>
              <p>{sortDisplay}</p>
          </div>
          {mainGrid}
        </div>
        <FilterBar />
        <FilterForm actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />
      </div>
    );
  }
}

Content.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default Content;
